// обычные строения
import {MINE_EXPLORATION_CONFIG} from "./factions/dwarves";

export const COMMON_BUILDING_CONFIGS = [
  {
    id: 'central_quarter_blue',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter neutral.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_indigo',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_sky_blue',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter blue.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_celadon',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter green.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_light_green',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter purple.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_dark_green',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter grey.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_violet',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_purple',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_pink',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_grey',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_light_grey',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_red',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_yellow',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_orange',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_bone',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_light_brown',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_brown',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'central_quarter_neutral',
    label: 'Центральный квартал',
    image: '/img/players/hexes/central quarter red.png',
    priceCoins: 4,
    isReconstructionProhibited: true
  },
  {
    id: 'quarter',
    label: 'Базовый квартал',
    image: '/img/hexes/quarter.f69660fa.png',
    priceCoins: 2,
    isReconstructionProhibited: true
  },
  {
    id: 'farm',
    label: 'Ферма',
    image: '/img/hexes/farm 0_1.1c690823.png',
    priceCoins: 3,
    isReconstructionProhibited: true
  },
  {
    id: 'barracks',
    label: 'Казарма',
    image: '/img/hexes/barracks.efab12f7.png',
    priceCoins: 2,
    isReconstructionProhibited: true
  },
  {
    id: 'road',
    label: 'Дорога',
    image: '/img/hexes/road.1f281346.png',
    priceCoins: 1
  }
];

// Специальные строения
export const SPECIAL_BUILDING_CONFIGS = [
  {
    id: 'palace',
    label: 'Дворец',
    image: '/img/hexes/special buildings/palace.4b9c923b.png',
    priceCoins: 10,
  },
  {
    id: 'warehouse',
    label: 'Склад',
    image: '/img/hexes/special buildings/warehouse.adf397b3.png',
    priceCoins: 10,
  },
  {
    id: 'military_camp',
    label: 'Лагерь',
    image: '/img/hexes/special buildings/military camp.1216e2cd.png',
    priceCoins: 8,
  },
  {
    id: 'arsenal',
    label: 'Арсенал',
    image: '/img/hexes/special buildings/arsenal.7f5423b5.png',
    priceCoins: 8,
  },
  {
    id: 'temple',
    label: 'Храм',
    image: '/img/hexes/special buildings/temple.17c08b3d.png',
    priceCoins: 6,
  },
  {
    id: 'guild',
    label: 'Гильдия',
    image: '/img/hexes/special buildings/guild.ee26d2b8.png',
    priceCoins: 4,
  },
  {
    id: 'fortress',
    label: 'Крепость',
    image: '/img/hexes/special buildings/fortress.05d960f6.png',
    buttonImage: '/img/hexes/special buildings/fortress button.6fed26ae.png',
    priceCoins: 8,
  },
];

export const ALL_BUILDING_CONFIGS = [
  ...COMMON_BUILDING_CONFIGS,
  ...SPECIAL_BUILDING_CONFIGS,
  // FACTIONS
  MINE_EXPLORATION_CONFIG,
]

// ключевые точки
export const KEY_POINT_CONFIGS = [
  {
    id: 'mine',
    label: 'Рудник',
    color: '#8B4513',
    image: '/img/hexes/mine.ecae90cd.png',
    incomeCoins: 1
  },
  {
    id: 'super_mine',
    label: 'Великий рудник',
    color: '#D2691E',
    image: '/img/hexes/super_mine.7a4a81f7.png',
    incomeCoins: 2
  },
  {
    id: 'ruins',
    label: 'Руины',
    color: '#808080',
    image: '/img/hexes/ruins.65862e11.png',
    incomeWinPoints: 2
  },
  {
    id: 'super_ruins',
    label: 'Великие руины',
    color: '#696969',
    image: '/img/hexes/super_ruins.97515170.png',
    incomeWinPoints: 4
  }
];


// ландшафные объекты на поле
export const TERRAIN_CONFIGS = [
  {
    id: 'mountain',
    label: 'Гора',
    color: '#8B7355',
    image: '/img/hexes/mountains/mountain_rock_1.862dc5c3.png'
  },
  {
    id: 'sea',
    label: 'Море',
    color: '#1E90FF',
    image: '/img/hexes/sea.154c9d0a.png'
  },
];